import React, {Component} from 'react';

class Landing extends Component {
    render() {
        window.location = "https://inbank.lt/"
    }
}

export default Landing;
